import { render, staticRenderFns } from "./TrainingSummaryStatsList.vue?vue&type=template&id=54a6037d&scoped=true&"
import script from "./TrainingSummaryStatsList.vue?vue&type=script&lang=ts&"
export * from "./TrainingSummaryStatsList.vue?vue&type=script&lang=ts&"
import style0 from "./TrainingSummaryStatsList.vue?vue&type=style&index=0&id=54a6037d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a6037d",
  null
  
)

export default component.exports